var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._m(0),_c('div',{staticClass:"btn-css"},[_c('van-button',{attrs:{"type":"primary","replace":"","to":"/"}},[_vm._v("去首页")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-css"},[_c('img',{attrs:{"src":require("@/assets/img/browser-404.png")}}),_c('p',[_vm._v("页面不存在")])])
}]

export { render, staticRenderFns }